const balance = (state) => state.balance.balance

const depositStatus = (state) => state.balance.depositStatus
const transferStatus = (state) => state.balance.transferStatus

const depositHistory = (state) => state.balance.depositHistory
const transferHistory = (state) => state.balance.transferHistory
const paymentHistory = (state) => state.balance.paymentHistory
const withdrawHistory = (state) => state.balance.withdrawHistory

export default {
  balance,

  depositStatus,
  transferStatus,

  depositHistory,
  transferHistory,
  paymentHistory,
  withdrawHistory,
}